import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Helmet } from "react-helmet";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

const Section = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Box>
);

const RefundCancellationPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Refund & Cancellation Policy – GroHair & GloSkin</title>
        <meta
          name="description"
          content="Read GroHair & GloSkin's Refund & Cancellation Policy for appointments and hair and skin care treatments."
        />
      </Helmet>

      <Header />

      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          py: 6,
          mt: { xs: 10, md: 10 },
          bgcolor: "#fff",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Refund & Cancellation Policy
        </Typography>
        <Typography color="text.secondary" mb={4}>
          Last updated: 29 August 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Section title="1. Appointment Cancellations">
          You may cancel or reschedule your appointment by contacting us at
          least 24 hours in advance by phone or email. This allows us to
          offer the slot to another client.
        </Section>

        <Section title="2. Late Cancellations & No-Shows">
          Cancellations made less than 24 hours before the scheduled
          appointment, or failure to show up without prior notice, may be
          subject to a rescheduling fee or forfeiture of any advance payment
          made, at the discretion of the clinic.
        </Section>

        <Section title="3. Refunds on Advance Payments">
          If you have made an advance payment for a consultation or
          treatment and cancel within the permitted notice period, the
          amount will be refunded or adjusted towards a future appointment,
          as per your preference. Refunds are processed to the original
          mode of payment within 7–10 business days.
        </Section>

        <Section title="4. Package & Course Treatments">
          For treatment packages or courses paid in advance, refunds for
          unused sessions are considered on a case-by-case basis and may be
          subject to a deduction for services already availed and any
          applicable processing charges.
        </Section>

        <Section title="5. Non-Refundable Items">
          Consultation fees already rendered, and any products or
          consumables opened or used as part of a treatment, are
          non-refundable.
        </Section>

        <Section title="6. How to Request a Cancellation or Refund">
          To request a cancellation or refund, please contact us at
          Kanchipuram@adgrohair.com or call +91 097510 56789 with your
          appointment details. Our team will guide you through the process.
        </Section>

        <Section title="7. Changes to This Policy">
          We may update this Refund & Cancellation Policy from time to time.
          Any changes will be posted on this page with an updated revision
          date.
        </Section>
      </Box>

      <Footer />
    </div>
  );
};

export default RefundCancellationPolicy;
